
import React, { useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // Import Quill's snow theme

import '../global.css';
import '../components/Theme.css';

const WYSIWYGEditor = () => {
  const [content, setContent] = useState("");

  // Toolbar customization
  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }], // Header levels
      ["bold", "italic", "underline", "strike"], // Text formatting
      [{ list: "ordered" }, { list: "bullet" }], // Lists
      ["link", "image"], // Links and images
      ["clean"], // Clear formatting
    ],
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "list",
    "bullet",
    "link",
    "image",
  ];

  // Handle content changes
  const handleContentChange = (value) => {
    setContent(value);
  };

  return (
    <div className="container mt-6">
      <div className="card">
          <div className="card-header mb-2">
              <h3 className="m-0">WYSIWYG Editor</h3>
          </div>
          <ReactQuill className="p-4"
            theme="snow"
            value={content}
            onChange={handleContentChange}
            modules={modules}
            formats={formats}
            placeholder="Start typing here..."
            style={{ height: "300px", marginBottom: "0px" }}
          />
          <h5 className="mt-5 ml-20">Editor Output:</h5>
          <div className="p-4 m-4 mt-0"
            style={{
              border: "1px solid #ccc",
              borderRadius: "5px",
              backgroundColor: "#f9f9f9",
            }}
            dangerouslySetInnerHTML={{ __html: content }}
          />
      </div>
    </div>
  );
};

export default WYSIWYGEditor;
